/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Charge/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Actions from './Actions/index'
import Amount from './Amount/index'
import EditInsuranceCode from './EditInsuranceCode/index'
import EditInsuranceCodeAction from './EditInsuranceCodeAction/index'
import React from 'react'
import ToothNumber from './ToothNumber/index'
import ToothSurface from './ToothSurface/index'
import Type from './Type/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Charge({
  children,
  viewPath = "/DesignSystem/ManualAutomations/Content/Content/ActiveAction/CreateProcedureReceivables/Content/Content/Claim/Content/Charges/Charge"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Charge.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-2nG5Pd': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<Type
  viewPath={`${viewPath}/Type`}
/>
<Amount
  viewPath={`${viewPath}/Amount`}
/>
<EditInsuranceCodeAction
  viewPath={`${viewPath}/EditInsuranceCodeAction`}
/>
<ToothNumber
  viewPath={`${viewPath}/ToothNumber`}
/>
<ToothSurface
  viewPath={`${viewPath}/ToothSurface`}
/>
<Actions
  viewPath={`${viewPath}/Actions`}
/>
</div>
<EditInsuranceCode
  viewPath={`${viewPath}/EditInsuranceCode`}
/>
{children}
</React.Fragment>)
}